import React, { useState } from "react"
import { motion } from "framer-motion"
import Button from "../common/Button"

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
  e.preventDefault()

  const text = `
Nouvelle demande de réservation au spa :

Nom: ${formData.name}
Téléphone: ${formData.phone}
Email: ${formData.email}
Message: ${formData.message}
  `

  const url = `https://wa.me/21697902051?text=${encodeURIComponent(text)}`

  const whatsappWindow = window.open(url, "_blank")

  if (whatsappWindow) {
    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    })
  }
}

  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-white rounded-[30px] shadow-2xl p-8 md:p-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111] text-center">
            Réservez votre Expérience Spa
          </h2>

          <p className="text-gray-600 text-center mt-4">
            Remplissez le formulaire puis cliquez sur "Envoyer via WhatsApp" pour nous transmettre votre demande de réservation.
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-10 space-y-6"
          >
            {/* Name */}
            <input
              type="text"
              name="name"
              placeholder="Votre Nom"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-5 py-4 rounded-2xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#b8955d]"
            />

            {/* Phone */}
            <input
              type="tel"
              name="phone"
              placeholder="Numéro Téléphone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-5 py-4 rounded-2xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#b8955d]"
            />

            {/* Email */}
            <input
              type="email"
              name="email"
              placeholder="Email (optional)"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-5 py-4 rounded-2xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#b8955d]"
            />

            {/* Message */}
            <textarea
              name="message"
              placeholder="Message..."
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className="w-full px-5 py-4 rounded-2xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#b8955d]"
            />

            {/* Submit */}
            <Button
              type="submit"
              variant="primary"
              size="lg"
              fullWidth
              ariaLabel="Envoyer une demande de réservation de spa"
            >
              Envoyer via WhatsApp
            </Button>
          </form>
        </motion.div>
      </div>
    </section>
  )
}